// Centralized social links for the site.
export const socials = {
    instagram:
        "https://www.instagram.com/ftaklakis_?igsh=MWx2ajB3dnhsMzgwaA%3D%3D&utm_source=qr",
    tiktok:
        "https://www.tiktok.com/@_kostef_?_r=1&_t=ZN-97s41BiDAmM",
    youtube: "https://youtube.com/@kostef_?si=UkC8niup81lgCTk7",
    linkedin:
        "https://www.linkedin.com/in/konstantinos-ftaklakis-9a2009364?utm_source=share_via&utm_content=profile&utm_medium=member_ios",
    facebook: "https://www.facebook.com/profile.php?id=61552139552246",
    x: "https://x.com/kostefk47785?s=11",
    telegram: "https://t.me/ftaklakis",
    whatsapp: "https://wa.me/message/QS4UF2F6Y5CSK1",
    viber: "https://viber.me/306945733294",
    email: "info@ftaklakismedia.com",
};

export const socialHandles = {
    instagram: "@ftaklakis_",
    tiktok: "@_kostef_",
    youtube: "@kostef_",
    linkedin: "Konstantinos Ftaklakis",
    facebook: "Kostas Ftaklakis",
    x: "@kostefk47785",
    telegram: "@ftaklakis",
    whatsapp: "Direct message",
    viber: "+30 694 573 3294",
    email: "info@ftaklakismedia.com",
};
